import React, { createContext, useContext, useState } from 'react';

interface NavigationContextType {
  drawerOpen: boolean;
  toggleDrawer: () => void;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const NavigationContext = createContext<NavigationContextType>({
  drawerOpen: false,
  toggleDrawer: () => {},
  openDrawer: () => {},
  closeDrawer: () => {},
});

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(prev => !prev);
  };

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const value = {
    drawerOpen,
    toggleDrawer,
    openDrawer,
    closeDrawer,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}; 